<template lang="pug">
.arrows(:class="`arrows--${direction}`")
  button.arrow.arrow--prev(:class="getClassTheme('prev')", @click="changePrev")
    icon(name="arrow")

  .arrows__counter(v-if="countSlides && currentIndex")
    .arrows__counter-number {{ currentIndex }}
    .arrows__counter-number {{ countSlides }}
  template(v-else)
    slot

  button.arrow.arrow--next(:class="getClassTheme('next')", @click="changeNext")
    icon(name="arrow")
</template>

<script>
export default {
  name: "Arrows",
  props: {
    theme: {
      type: String,
      default: "black", // black, white
    },
    direction: {
      type: String,
      default: "horizontal", // vertical, horizontal
    },
    isPrevDisabled: {
      type: Boolean,
      default: false,
    },
    isNextDisabled: {
      type: Boolean,
      default: false,
    },
    countSlides: {
      type: Number,
      default: 0,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    getClassTheme(type) {
      return [
        { "arrow--disabled": (type === "prev" && this.isPrevDisabled) || (type === "next" && this.isNextDisabled) },
        `arrow--${this.theme}`,
      ]
    },
    changePrev() {
      this.$emit("changePrev");
    },
    changeNext() {
      this.$emit("changeNext");
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../style/arrows";
</style>
